import React from 'react';
import { SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * EmptyState — quando filtros nao retornam canais.
 * Botao "Limpar filtros" so aparece se hasActiveFilters.
 */
const EmptyState = ({ hasActiveFilters, onClearFilters }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '64px 24px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 14,
        color: 'var(--dp-text-secondary)',
        fontFamily: 'var(--dp-font)',
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 16,
          background: 'var(--dp-blue-subtle)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--dp-blue-500)',
        }}
      >
        <SearchX size={28} />
      </div>
      <div>
        <h3
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 600,
            color: 'var(--dp-text-primary)',
          }}
        >
          {t('viralNiches.empty_no_channels_title')}
        </h3>
        <p
          style={{
            margin: '4px 0 0 0',
            fontSize: 13,
            color: 'var(--dp-text-tertiary)',
          }}
        >
          {t('viralNiches.empty_no_channels_desc')}
        </p>
      </div>
      {hasActiveFilters && (
        <button
          type="button"
          className="dp-btn-secondary"
          onClick={onClearFilters}
          style={{ marginTop: 6 }}
        >
          {t('viralNiches.empty_clear_filters')}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
